import React from "react";
import Footer from "../Shared/Footer/Footer";
import Navigation from "../Shared/Navigation/Navigation";

const ContactUs = () => {
  return (
    <div className="contact-container">
      <Navigation></Navigation>
      <h1>this is contact page</h1>
      <Footer></Footer>
    </div>
  );
};

export default ContactUs;
